import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DocumentSessionPartial } from 'src/app/domain/entities/partials/documents/document-session.partial';
import { EditSectionService } from '../../../../services/edit-section.service';
import { SectionItemComponent } from './section-item/section-item.component';

@Component({
    selector: 'section-options',
    templateUrl: 'section-options.component.html',
    styleUrl: 'section-options.component.scss',
    imports: [CommonModule, SectionItemComponent, TranslatePipe],
})
export class SectionOptionsComponent {
    public section = input.required<DocumentSessionPartial>();
    public close = output<void>();
    public changeNameSession = output<void>();
    public typoAllTextsIa = output<void>();
    public editDescription = output<void>();
    public isHidden = input(true);
    public isChecklistMode = input(false);

    /** `true` quando a seção já tem descrição (muda o rótulo: adicionar vs editar). */
    public hasDescription = computed(() => !!(this.section()?.description ?? '').trim());

    // * [Injects]
    public editSessionService = inject(EditSectionService);
}
